import formatIsoString from './formatIso86Date';
import { PENDING_STATUS } from '../constants/appointmentStatuses';

export default function getTimeOptions(slots) {
    return slots.map((appointment) => {
        return (appointment.status === PENDING_STATUS && !appointment.isBlocked)  ? { label: formatIsoString(appointment.startsAt), value: appointment } : null;
    }).filter(slot => slot);
}